<template>
  <div class="task">
    <Header titles="我的发布"></Header>
    
    <PullRefresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功" head-height="50">
      <List
        class="task-list"
        :immediate-check="false"
        v-model="loading"
        :offset="300"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadTask"
        >
        <router-link :to="{path:'/get',query: {task_id: item.task_id, took: 0}}" class="eve-mytask" :id="item.id" v-for="(item, index) in user" :key="index">
          <div class="task-list__header" >
            <div class="task-header__left">{{item.title}}</div>
            <div class="task-header__right">{{item.status}} </div>
          </div>
          <div class="task-main">
            <div class="task-main__left">
              <div class="task-left__type specific">
                {{item.task_mech}}
              </div>
              <template v-for="(tag, index) in item.task_tag" >
                <div class="task-left__type" v-if="index < 3 && tag" :key="'tag'+ index">
                  {{tag}}
                </div>
              </template>
              <div class="task-left__jin" v-if="item.urgent_level == '紧急'">
                {{item.urgent_level}}
              </div>
              <div class="task-left__jin" style="background:#229CD6">
                {{item.urgent_level == 0 ? '外部任务': '内部任务'}}
              </div>
            </div>
          </div>
          <div class="footer-time">
            <span>{{item.plan_start_time}}</span>
            <span> ~ </span>
            <span>{{item.plan_end_time}}</span>
          </div>
          <div class="task-footer">
            <div class="task-header__right">￥{{item.award | strChange}}</div>
            <div class="task-footer-type">
              <div class="footer-nos" v-if="item.status === '已关闭' && item.is_evaluate == 0">待评价</div>
              <div class="footer-nos" v-if="item.status === '已关闭' && item.is_evaluate == 1" style="color:#ccc">已评价</div>
            </div>
          </div>
        </router-link>
      </List>
    </PullRefresh>
  </div>
</template>

<script>
import { PullRefresh, List } from 'vant'
import { getMyPublisTasks } from '@/api/api/task'
import Header from '@/components/header'

export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      user : [],
      page: 1,
      more: true,
      nomore: true
    }
  },
  components: {
    PullRefresh,
    List,
    Header
  },
  created() {
    this.getList()
  },
  mounted() {
    window.addEventListener('scroll', this.onSrcoll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onSrcoll)
  },
  methods: {
    randomRgb(x) {
      var col = ['#d9f5f8', '#ffedd9', '#eceaff', '#ffe5e6']
      var bor = ['#57ccd8', '#ff9b2b', '#938bff', '#ff6d6e']
      var s = x%4
        return {
          'background-color': col[s],
         "border-left": "6px solid "+bor[s]+""
        }
    },
    getList() {
      getMyPublisTasks().then(res => {
        console.log(res.data.data.list)
        if (res.data.errorCode == '0') {
          res.data.data.list.forEach(ele => {
            ele.task_tag = ele.task_tag && ele.task_tag.split(',')
          })
          this.user = [...this.user,...res.data.data.list]
          if (res.data.data.list.length < 10) this.finished = true
        }
      })
    },
    loadTask() {
      console.log(123)
    },
    onSrcoll() {
      if(this.$route.path != '/home/task') return
      if(document.documentElement.scrollTop + window.innerHeight >= (document.body.offsetHeight-800) && this.more == true && this.nomore) {
        this.page += 1
        this.more = false
        getMyPublisTasks(this.page).then(res => {
          console.log(res)
          if (res.data.errorCode == 0) {
            if(!res.data.data.list.length && this.nomore) {
              this.finished = true
              this.nomore = false
              this.more = true
              return
            } else {
              res.data.data.list.forEach(ele => {
                ele.task_tag = ele.task_tag.split(',')
              })
              this.user = [...this.user,...res.data.data.list]
            }
          }
          setTimeout(() => {
            this.more = true
          },1500)
        })
      }
    },
    onRefresh() {
      this.user = []
      this.getList()
      this.page = 1
      this.nomore = true
      this.more = true
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
.task {
  // background: #F6F6F4;
  min-height: 100%;
  .task-header {
    display: flex;
    align-items: center;
    height: 64px;
    color: white;
    font-size: 17px;
    width: 100%;
    background: white;
    position: fixed;
    top: 0;
    z-index: 99;
    justify-content: space-between;
    padding: 0 24px;
    .header-title {
      font-weight: 600;
      font-size: 30px;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #25245d;
    }
    img {
      width: 25px;
      height: 23px;
    }
  }
  .task-list {
      min-height: 600px;
      margin-top: 44px;
      padding: 15px 24px 90px 24px;
      overflow-y: auto;
    .eve-mytask {
      // border-radius: 6px;
      display: block;
      // height: 138px;
      margin-bottom: 16px;
      border-bottom: 1px solid #ccc;
      // padding: 22px 0 0 0;
      .task-footer {
        display: flex;
        justify-content: space-between;
        // height: 38px;
        margin-bottom: 4px;
        .task-footer-type {
          display: flex;
            .footer-nos {
              color: #F91400;
            }
            .footer-derl {
              width: 72px;
              // height: 25px;
              text-align: center;
              // line-height: 25px;
              color: white;
              background: #BE0000;
              border-radius: 2px;
          }
        }
        .task-header__right {
          font-size:18px;
          font-weight:600;
          color:#FF7A15;
          line-height:30px;
          .sizelit {
            font-size: 10px;
          }
        }
      }
      .footer-time {
        padding: 6px 0;
        color: #828593;
      }
      .task-list__header {
        display: flex;
        justify-content: space-between;
        .task-header__left {
          height:21px;
          font-weight: 700;
          font-size: 15px;
          color: #25245D;
          letter-spacing: 0.5px;
        }
        .task-header__right {
          color: #0286FF;
        }
      }
    }
    .task-main {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      align-items: center;
      .task-main__right {
        color: #BE0000;
        align-items: center;
      }
      .task-main__left {
        display: flex;
        align-items: center;
        .task-left__type {
          padding: 0 6px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
          background: #099B17;
          font-size: 12px;
          color:white;
          margin-right: 8px;
        }
        .specific {
          background: #FF7A15;
        }
        .task-left__jin {
          padding: 0 6px;
          height: 20px;
          border-radius: 50%;
          background: #F91400;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color:white;
        }
      }
        
    }
  }
}
</style>